import styled from 'styled-components';
import { Select } from 'antd';

export const SelectTab = styled(Select)`
width: 200px;
.ant-select-selection{
  border-radius : 0px;
}
.ant-select-arrow {
  color: ${props => props.theme.fontColors.tbody};
  width: 40px;
  height: 100%;
  top: 6px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.border.pill};
  background: #f5f5f5;
}
.ant-select-selection--multiple{
  min-height: 40px;
}
.ant-select-selection--multiple .ant-select-selection__rendered{
  margin-right: 28px;
}
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li{
  height:auto;
  max-width: 150px;
  margin-top: 6px;
  padding-top: 2px;
  line-height: normal;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    max-width: calc(100% - 20px);
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  // margin-bottom: 30px;
  width: calc(100% - 80px);
}
@media only screen and (min-width: 728px) and (max-width: 1023px) {
  margin-bottom: 30px;
}
@media only screen and (min-width: 1023px) and (max-width: 1439px) {
   width: 200px;
}
`;

export const PlaceHolder = styled.div`
margin-left: 0px;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.placeholder};
@media only screen and (min-width: 320px) and (max-width: 767px) {
 font-size: ${props => props.theme.fontSize.secondary};
  }
`;